import * as React from "react";
import styled from "styled-components";
import { useCallback } from "react";
import { IfPermitted } from "components/common";
import { TableHead, TableHeaderCell } from "views/components/datatable";
import IfInteractive from "views/components/dashboard/IfInteractive";
import { INVESTIGATION_ATTRIBUTES } from "security-app/components/Investigations/Constants";
import useUsersAndTeams from "security-app/components/Investigations/hooks/useUsersAndTeams";
import { useGetPriorities } from "security-app/hooks/useInvestigationsAPI";
import useLicenseCheck from "license/useLicenseCheck";
import InvalidLicenseWidgetInfo from "search/InvalidLicenseWidgetInfo";
import AttributeSortIcon from "views/components/widgets/overview-configuration/AttributeSortIcon";
import InvestigationsTableRow from "./InvestigationsTableRow";
import InvestigationsWidgetSortConfig from "../logic/InvestigationsWidgetSortConfig";
const TableWrapper = styled.div`
  overflow: auto;
`;
const ActionsHeader = styled(TableHeaderCell)`
  && {
    min-width: auto;
    width: 35px;
  }
`;
const InvestigationsTable = ({ investigations, config, onSortChange, setLoadingState, onArchive, onDelete }) => {
  const usersAndTeams = useUsersAndTeams();
  const { priorities } = useGetPriorities(true);
  const { security } = useLicenseCheck();
  const _onSortChange = useCallback(
    (fieldName, nextDirection) => onSortChange(new InvestigationsWidgetSortConfig(fieldName, nextDirection)),
    [onSortChange]
  );
  if (!(security == null ? void 0 : security.isValid)) {
    return /* @__PURE__ */ React.createElement(InvalidLicenseWidgetInfo, { featureName: "Investigation" });
  }
  return /* @__PURE__ */ React.createElement(TableWrapper, null, /* @__PURE__ */ React.createElement("table", { className: "table table-condensed" }, /* @__PURE__ */ React.createElement(TableHead, null, /* @__PURE__ */ React.createElement("tr", null, config.fields.toArray().map((field) => {
    var _a, _b, _c, _d;
    return /* @__PURE__ */ React.createElement(TableHeaderCell, { key: field }, (_b = (_a = INVESTIGATION_ATTRIBUTES[field]) == null ? void 0 : _a.title) != null ? _b : field, /* @__PURE__ */ React.createElement(
      AttributeSortIcon,
      {
        onSortChange: _onSortChange,
        attribute: field,
        attributeTitle: (_d = (_c = INVESTIGATION_ATTRIBUTES[field]) == null ? void 0 : _c.title) != null ? _d : field,
        activeAttribute: config.sort.field,
        activeDirection: config.sort.direction,
        setLoadingState
      }
    ));
  }), /* @__PURE__ */ React.createElement(IfInteractive, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "investigations:edit" }, /* @__PURE__ */ React.createElement(ActionsHeader, null))))), /* @__PURE__ */ React.createElement("tbody", null, investigations == null ? void 0 : investigations.map((investigation) => /* @__PURE__ */ React.createElement(
    InvestigationsTableRow,
    {
      key: investigation.id,
      priorities,
      investigation,
      onArchive,
      onDelete,
      usersAndTeams,
      fields: config.fields
    }
  )))));
};
export default InvestigationsTable;
